import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const HelpText = styled.p.attrs(({ id }) => ({
    className: 'form-text',
    id,
}))`
    font-size: 0.8rem;
    color: ${props => props.theme.admin.colors.heading};
    font-weight: 300;
`

const Help = ({ id, help, ...props }) => {
    if (help) {
        return typeof help === 'function' ? (
            help()
        ) : (
            <HelpText id={id} {...props}>
                {help}
            </HelpText>
        )
    }

    return null
}

Help.displayName = 'Help'

Help.propTypes = {
    id: PropTypes.string.isRequired,
    help: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
}

export default Help
